/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20260611 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Cellphone } from 'src/app/_model/cellphone';

@Injectable()
export abstract class CellphonesDaoService implements Resetable {
  public abstract saveCellphones(cellphones: Cellphone[]): Promise<void>;
  public abstract getCellphones(): Promise<Cellphone[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
